import React from "react";
import SecondaryContainer from "./SecondaryContainer";
import GeminiInput from "./GeminiInput";

const DoYogaWithAi = () => {
    return (
        <div className="bg-[#8FDDE7] min-h-screen w-full">
            <GeminiInput />
            <SecondaryContainer />
        </div>
    );
};

export default DoYogaWithAi;
